import { jFactoryBootstrap } from "jfactory/src/indexLibs.mjs";
export { JFactoryPromise } from "jfactory/src/indexLibs.mjs";

jFactoryBootstrap(true)